// extracted by mini-css-extract-plugin
export default {"tableHeaderCell":"DamageMatrix_tableHeaderCell__yKwKD"};